var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "broadcast-requests" } },
    [
      _c(
        "AppBreadCrumb",
        { attrs: { paths: [{ title: _vm.$t("wp.whatsapp") }], select: true } },
        [
          _vm.initialized && _vm.status.purchased
            ? _c(
                "a-button",
                {
                  staticClass: "actionButtonBreadcrumb",
                  attrs: { type: "danger" },
                  on: { click: _vm.unsubscribe },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("wp.unsubscribe")) +
                      "\n        "
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex",
          staticStyle: { "background-color": "#ffffff" },
        },
        [
          _c(
            "div",
            { staticClass: "side-menubar-wrapper" },
            [
              _c("WhatsappMenu", {
                attrs: {
                  "selected-page": "broadcast",
                  "selected-sub-page": "requests",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "main-content" },
            [
              !_vm.whatsappPlanExists
                ? _c("ActivateWhatsappAlert")
                : _c("div", [
                    _vm.formVisible
                      ? _c(
                          "div",
                          [
                            _c("NewBroadcastMessage", {
                              attrs: {
                                "on-success": _vm.addItem,
                                "on-cancel": function () {
                                  return (_vm.formVisible = false)
                                },
                              },
                            }),
                          ],
                          1
                        )
                      : _c(
                          "div",
                          [
                            _c(
                              "div",
                              { staticClass: "toolbar" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "segmented-btn-container" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "btn",
                                        class: { active: !_vm.archiveMode },
                                        on: {
                                          click: function ($event) {
                                            _vm.archiveMode = false
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "container" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "label" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t("wp.active")
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "badge" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "badge-container",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.stats.active)
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "btn",
                                        class: { active: _vm.archiveMode },
                                        on: {
                                          click: function ($event) {
                                            _vm.archiveMode = true
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "container" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "label" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "material-icons mr-1",
                                                  },
                                                  [_vm._v(" archive ")]
                                                ),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("wp.archived")
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "badge" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "badge-container",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.stats.archived)
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.createBroadcastMessage },
                                  },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.$t("wp.createBroadcastMessage")
                                        ) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", {
                              staticClass:
                                "w-100 d-flex justify-content-end mt-3",
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "m-5" },
                              [
                                _c("a-table", {
                                  key: "vtable-" + _vm.renderCount,
                                  attrs: {
                                    locale: {
                                      emptyText: _vm.$t("message.noData"),
                                    },
                                    rowKey: "_id",
                                    columns: _vm.cols,
                                    dataSource: _vm.items,
                                    pagination: false,
                                    customRow: function (record) {
                                      return {
                                        props: {},
                                        on: {
                                          mouseover: function (event) {
                                            _vm.rowMouseOver(record)
                                          },
                                          mouseleave: function (event) {
                                            _vm.rowMouseLeave(record)
                                          }, // mouse leave row
                                          click: function () {
                                            _vm.showDetailRecord(record)
                                          },
                                        },
                                      }
                                    },
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "avatar",
                                      fn: function (text, record) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "user-segment-avatar text-center",
                                              class: {
                                                "user-segment-avatar-odd":
                                                  _vm.isRowNumberOdd(record),
                                              },
                                            },
                                            [
                                              _c(
                                                "md-highlight-text",
                                                {
                                                  staticClass: "text-center",
                                                  attrs: { "md-term": "term" },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(
                                                        (record.title || "")
                                                          .slice(0, 2)
                                                          .toUpperCase()
                                                      ) +
                                                      "\n                                    "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "description",
                                      fn: function (text, record) {
                                        return _c("span", {}, [
                                          _c(
                                            "span",
                                            {
                                              directives: [
                                                {
                                                  name: "tippy",
                                                  rawName: "v-tippy",
                                                  value: {
                                                    followCursor: true,
                                                    placement: "bottom-end",
                                                  },
                                                  expression:
                                                    "{ followCursor: true, placement: 'bottom-end' }",
                                                },
                                              ],
                                              staticClass: "text-truncate",
                                              attrs: {
                                                content: record.description,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  record.description.slice(
                                                    0,
                                                    15
                                                  ) + "..."
                                                )
                                              ),
                                            ]
                                          ),
                                        ])
                                      },
                                    },
                                    {
                                      key: "numbers",
                                      fn: function (text, record) {
                                        return _c("span", {}, [
                                          _vm._v(
                                            _vm._s(
                                              !!record.all
                                                ? _vm.$_.get(
                                                    _vm.contacts,
                                                    "length"
                                                  ) +
                                                    " " +
                                                    _vm.$t("wp.numbers")
                                                : _vm.$_.get(
                                                    record,
                                                    "customPhoneNumbers.length"
                                                  )
                                                ? _vm.$_.get(
                                                    record,
                                                    "customPhoneNumbers.length"
                                                  ) +
                                                  " " +
                                                  _vm.$t("wp.numbers")
                                                : "" +
                                                  _vm.$t("wp.noNumbersAdded")
                                            )
                                          ),
                                        ])
                                      },
                                    },
                                    {
                                      key: "messages",
                                      fn: function (text, record) {
                                        return _c("span", {}, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$_.get(
                                                record,
                                                "messages.length"
                                              ) > 1
                                                ? _vm.$_.get(
                                                    record,
                                                    "messages.length"
                                                  ) +
                                                    " " +
                                                    _vm.$t("wp.messages")
                                                : _vm.$_.get(
                                                    record,
                                                    "messages.length"
                                                  ) +
                                                    " " +
                                                    _vm.$t("wp.message")
                                            )
                                          ),
                                        ])
                                      },
                                    },
                                    {
                                      key: "successMessageRatio",
                                      fn: function (text, record) {
                                        return _c(
                                          "span",
                                          {},
                                          [
                                            _vm.getTotalMessageSent(record) > 0
                                              ? _c(
                                                  "b-progress",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "tippy",
                                                        rawName: "v-tippy",
                                                        value: {
                                                          followCursor: true,
                                                          placement:
                                                            "bottom-end",
                                                        },
                                                        expression:
                                                          "{ followCursor: true, placement: 'bottom-end' }",
                                                      },
                                                    ],
                                                    attrs: {
                                                      max: 100,
                                                      "show-value": "",
                                                      content:
                                                        _vm.getSuccessRatioTooltipText(
                                                          record
                                                        ),
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "b-progress-bar",
                                                      {
                                                        attrs: {
                                                          value:
                                                            _vm.getSuccessMessageRatio(
                                                              record
                                                            ),
                                                          variant: "success",
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            "\n                                            " +
                                                              _vm._s(
                                                                _vm.getSuccessMessageRatio(
                                                                  record
                                                                ) + "%"
                                                              ) +
                                                              "\n                                        "
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-progress-bar",
                                                      {
                                                        attrs: {
                                                          value:
                                                            100 -
                                                            _vm.getSuccessMessageRatio(
                                                              record
                                                            ),
                                                          variant: "danger",
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            "\n                                            " +
                                                              _vm._s(
                                                                100 -
                                                                  _vm.getSuccessMessageRatio(
                                                                    record
                                                                  ) +
                                                                  "%"
                                                              ) +
                                                              "\n                                        "
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _c(
                                                  "b-progress",
                                                  {
                                                    attrs: {
                                                      max: 100,
                                                      "show-value": "",
                                                    },
                                                  },
                                                  [
                                                    _c("b-progress-bar", {
                                                      attrs: {
                                                        value: 0,
                                                        variant: "success",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                          ],
                                          1
                                        )
                                      },
                                    },
                                    {
                                      key: "usageCost",
                                      fn: function (text, record) {
                                        return _c("span", {}, [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.getUsageCost(record) + " ₺"
                                              ) +
                                              "\n                            "
                                          ),
                                        ])
                                      },
                                    },
                                    {
                                      key: "createdAt",
                                      fn: function (text, record) {
                                        return _c("span", {}, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.createdAtHumanize(record)
                                            )
                                          ),
                                        ])
                                      },
                                    },
                                    {
                                      key: "progress",
                                      fn: function (text, record) {
                                        return _c(
                                          "span",
                                          {},
                                          [
                                            record.status === "created"
                                              ? _c("a-progress", {
                                                  directives: [
                                                    {
                                                      name: "tippy",
                                                      rawName: "v-tippy",
                                                      value: {
                                                        followCursor: true,
                                                        placement: "bottom-end",
                                                      },
                                                      expression:
                                                        "{ followCursor: true, placement: 'bottom-end' }",
                                                    },
                                                  ],
                                                  attrs: {
                                                    percent:
                                                      _vm.getPercent(record),
                                                    size: "small",
                                                    status: "normal",
                                                    content:
                                                      _vm.getProgressText(
                                                        record
                                                      ),
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            record.status === "scheduled"
                                              ? _c("a-progress", {
                                                  directives: [
                                                    {
                                                      name: "tippy",
                                                      rawName: "v-tippy",
                                                      value: {
                                                        followCursor: true,
                                                        placement: "bottom-end",
                                                      },
                                                      expression:
                                                        "{ followCursor: true, placement: 'bottom-end' }",
                                                    },
                                                  ],
                                                  attrs: {
                                                    percent:
                                                      _vm.getPercent(record),
                                                    size: "small",
                                                    status: "normal",
                                                    content:
                                                      _vm.getProgressText(
                                                        record
                                                      ),
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            record.status === "queued"
                                              ? _c("a-progress", {
                                                  directives: [
                                                    {
                                                      name: "tippy",
                                                      rawName: "v-tippy",
                                                      value: {
                                                        followCursor: true,
                                                        placement: "bottom-end",
                                                      },
                                                      expression:
                                                        "{ followCursor: true, placement: 'bottom-end' }",
                                                    },
                                                  ],
                                                  attrs: {
                                                    percent:
                                                      _vm.getPercent(record),
                                                    size: "small",
                                                    status: "normal",
                                                    content:
                                                      _vm.getProgressText(
                                                        record
                                                      ),
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            record.status === "running"
                                              ? _c("a-progress", {
                                                  directives: [
                                                    {
                                                      name: "tippy",
                                                      rawName: "v-tippy",
                                                      value: {
                                                        followCursor: true,
                                                        placement: "bottom-end",
                                                      },
                                                      expression:
                                                        "{ followCursor: true, placement: 'bottom-end' }",
                                                    },
                                                  ],
                                                  attrs: {
                                                    percent:
                                                      _vm.getPercent(record),
                                                    size: "small",
                                                    status: "active",
                                                    content:
                                                      _vm.getProgressText(
                                                        record
                                                      ),
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            record.status === "completed"
                                              ? _c("a-progress", {
                                                  directives: [
                                                    {
                                                      name: "tippy",
                                                      rawName: "v-tippy",
                                                      value: {
                                                        followCursor: true,
                                                        placement: "bottom-end",
                                                      },
                                                      expression:
                                                        "{ followCursor: true, placement: 'bottom-end' }",
                                                    },
                                                  ],
                                                  attrs: {
                                                    percent:
                                                      _vm.getPercent(record),
                                                    size: "small",
                                                    status: "success",
                                                    content:
                                                      _vm.getProgressText(
                                                        record
                                                      ),
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            record.status === "failed"
                                              ? _c("a-progress", {
                                                  directives: [
                                                    {
                                                      name: "tippy",
                                                      rawName: "v-tippy",
                                                      value: {
                                                        followCursor: true,
                                                        placement: "bottom-end",
                                                      },
                                                      expression:
                                                        "{ followCursor: true, placement: 'bottom-end' }",
                                                    },
                                                  ],
                                                  attrs: {
                                                    percent:
                                                      _vm.getPercent(record),
                                                    size: "small",
                                                    status: "exception",
                                                    content:
                                                      _vm.getProgressText(
                                                        record
                                                      ),
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            record.status === "cancelled"
                                              ? _c("a-progress", {
                                                  directives: [
                                                    {
                                                      name: "tippy",
                                                      rawName: "v-tippy",
                                                      value: {
                                                        followCursor: true,
                                                        placement: "bottom-end",
                                                      },
                                                      expression:
                                                        "{ followCursor: true, placement: 'bottom-end' }",
                                                    },
                                                  ],
                                                  attrs: {
                                                    percent:
                                                      _vm.getPercent(record),
                                                    size: "small",
                                                    status: "exception",
                                                    content:
                                                      _vm.getProgressText(
                                                        record
                                                      ),
                                                  },
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      },
                                    },
                                    {
                                      key: "status",
                                      fn: function (text, record) {
                                        return _c(
                                          "span",
                                          {},
                                          [
                                            record.status === "created"
                                              ? _c("a-badge", {
                                                  attrs: {
                                                    color: "cyan",
                                                    text: _vm.$t("wp.created"),
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            record.status === "scheduled"
                                              ? _c("a-badge", {
                                                  attrs: {
                                                    color: "volcano",
                                                    text: _vm.$t(
                                                      "wp.scheduled"
                                                    ),
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            record.status === "queued"
                                              ? _c("a-badge", {
                                                  attrs: {
                                                    color: "gray",
                                                    text: _vm.$t("wp.queued"),
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            record.status === "running"
                                              ? _c("a-badge", {
                                                  attrs: {
                                                    color: "blue",
                                                    text: _vm.$t("wp.running"),
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            record.status === "completed"
                                              ? _c("a-badge", {
                                                  attrs: {
                                                    color: "green",
                                                    text: _vm.$t(
                                                      "wp.completed"
                                                    ),
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            record.status === "failed"
                                              ? _c("a-badge", {
                                                  attrs: {
                                                    color: "red",
                                                    text: _vm.$t("wp.failed"),
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            record.status === "cancelled"
                                              ? _c("a-badge", {
                                                  attrs: {
                                                    color: "yellow",
                                                    text: _vm.$t(
                                                      "wp.cancelled"
                                                    ),
                                                  },
                                                })
                                              : _vm._e(),
                                          ],
                                          1
                                        )
                                      },
                                    },
                                    {
                                      key: "operation",
                                      fn: function (text, record) {
                                        return _c(
                                          "span",
                                          {
                                            staticClass:
                                              "d-flex flex-row justify-content-center operation-buttons",
                                          },
                                          [
                                            !_vm.archiveMode &&
                                            ![
                                              "queued",
                                              "running",
                                              "created",
                                            ].includes(record.status)
                                              ? _c(
                                                  "span",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          _vm.archiveMode ===
                                                          false,
                                                        expression:
                                                          "archiveMode === false",
                                                      },
                                                    ],
                                                    staticClass:
                                                      "material-icons mx-2 text-primary operation-button",
                                                    on: {
                                                      click: function () {
                                                        return _vm.markAsArchived(
                                                          record
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                    archive\n                                "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "material-icons mx-2 text-secondary operation-button",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.showDetailRecord(
                                                      record
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                    document_scanner\n                                "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            ![
                                              "completed",
                                              "failed",
                                              "cancelled",
                                            ].includes(record.status)
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "material-icons mx-2 text-danger operation-button",
                                                    on: {
                                                      click: function () {
                                                        return _vm.cancelBroadcast(
                                                          record
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                    cancel\n                                "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        )
                                      },
                                    },
                                  ]),
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.selectedRowRecord
                              ? _c(
                                  "a-modal",
                                  {
                                    staticClass: "details",
                                    attrs: {
                                      centered: "",
                                      visible: !!_vm.selectedRowRecord,
                                      footer: null,
                                      closable: true,
                                      width: "1080px",
                                    },
                                    on: {
                                      cancel: function ($event) {
                                        _vm.selectedRowRecord = null
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "details__content" },
                                      [
                                        _c(
                                          "a-card",
                                          {
                                            staticClass: "card-container",
                                            attrs: { bordered: false },
                                          },
                                          [
                                            _c("a-card-meta", {
                                              staticClass:
                                                "mb-2 p-2 text-capitalize",
                                              attrs: {
                                                title:
                                                  _vm.selectedRowRecord.title,
                                                description:
                                                  _vm.selectedRowRecord
                                                    .description,
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "card-summary" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "card-summary-item",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "details-subtitle",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "wp.broadcast.status"
                                                            )
                                                          ) + " :"
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.selectedRowRecord
                                                      .status === "created"
                                                      ? _c("a-badge", {
                                                          attrs: {
                                                            color: "cyan",
                                                            text: "Created",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.selectedRowRecord
                                                      .status === "scheduled"
                                                      ? _c("a-badge", {
                                                          attrs: {
                                                            color: "volcano",
                                                            text: "Scheduled",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.selectedRowRecord
                                                      .status === "queued"
                                                      ? _c("a-badge", {
                                                          attrs: {
                                                            color: "gray",
                                                            text: "Queued",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.selectedRowRecord
                                                      .status === "running"
                                                      ? _c("a-badge", {
                                                          attrs: {
                                                            color: "blue",
                                                            text: "Running",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.selectedRowRecord
                                                      .status === "completed"
                                                      ? _c("a-badge", {
                                                          attrs: {
                                                            color: "green",
                                                            text: "Completed",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.selectedRowRecord
                                                      .status === "failed"
                                                      ? _c("a-badge", {
                                                          attrs: {
                                                            color: "red",
                                                            text: "Failed",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.selectedRowRecord
                                                      .status === "cancelled"
                                                      ? _c("a-badge", {
                                                          attrs: {
                                                            color: "yellow",
                                                            text: "Cancelled",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "card-summary-item",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "details-subtitle",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "wp.broadcast.progress"
                                                            )
                                                          ) + " :"
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.selectedRowRecord
                                                      .status === "created"
                                                      ? _c("a-progress", {
                                                          directives: [
                                                            {
                                                              name: "tippy",
                                                              rawName:
                                                                "v-tippy",
                                                              value: {
                                                                followCursor: true,
                                                                placement:
                                                                  "bottom-end",
                                                              },
                                                              expression:
                                                                "{ followCursor: true, placement: 'bottom-end' }",
                                                            },
                                                          ],
                                                          attrs: {
                                                            percent:
                                                              _vm.getPercent(
                                                                _vm.selectedRowRecord
                                                              ),
                                                            size: "small",
                                                            status: "normal",
                                                            content:
                                                              _vm.getProgressText(
                                                                _vm.selectedRowRecord
                                                              ),
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.selectedRowRecord
                                                      .status === "scheduled"
                                                      ? _c("a-progress", {
                                                          directives: [
                                                            {
                                                              name: "tippy",
                                                              rawName:
                                                                "v-tippy",
                                                              value: {
                                                                followCursor: true,
                                                                placement:
                                                                  "bottom-end",
                                                              },
                                                              expression:
                                                                "{ followCursor: true, placement: 'bottom-end' }",
                                                            },
                                                          ],
                                                          attrs: {
                                                            percent:
                                                              _vm.getPercent(
                                                                _vm.selectedRowRecord
                                                              ),
                                                            size: "small",
                                                            status: "normal",
                                                            content:
                                                              _vm.getProgressText(
                                                                _vm.selectedRowRecord
                                                              ),
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.selectedRowRecord
                                                      .status === "queued"
                                                      ? _c("a-progress", {
                                                          directives: [
                                                            {
                                                              name: "tippy",
                                                              rawName:
                                                                "v-tippy",
                                                              value: {
                                                                followCursor: true,
                                                                placement:
                                                                  "bottom-end",
                                                              },
                                                              expression:
                                                                "{ followCursor: true, placement: 'bottom-end' }",
                                                            },
                                                          ],
                                                          attrs: {
                                                            percent:
                                                              _vm.getPercent(
                                                                _vm.selectedRowRecord
                                                              ),
                                                            size: "small",
                                                            status: "normal",
                                                            content:
                                                              _vm.getProgressText(
                                                                _vm.selectedRowRecord
                                                              ),
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.selectedRowRecord
                                                      .status === "running"
                                                      ? _c("a-progress", {
                                                          directives: [
                                                            {
                                                              name: "tippy",
                                                              rawName:
                                                                "v-tippy",
                                                              value: {
                                                                followCursor: true,
                                                                placement:
                                                                  "bottom-end",
                                                              },
                                                              expression:
                                                                "{ followCursor: true, placement: 'bottom-end' }",
                                                            },
                                                          ],
                                                          attrs: {
                                                            percent:
                                                              _vm.getPercent(
                                                                _vm.selectedRowRecord
                                                              ),
                                                            size: "small",
                                                            status: "active",
                                                            content:
                                                              _vm.getProgressText(
                                                                _vm.selectedRowRecord
                                                              ),
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.selectedRowRecord
                                                      .status === "completed"
                                                      ? _c("a-progress", {
                                                          directives: [
                                                            {
                                                              name: "tippy",
                                                              rawName:
                                                                "v-tippy",
                                                              value: {
                                                                followCursor: true,
                                                                placement:
                                                                  "bottom-end",
                                                              },
                                                              expression:
                                                                "{ followCursor: true, placement: 'bottom-end' }",
                                                            },
                                                          ],
                                                          attrs: {
                                                            percent:
                                                              _vm.getPercent(
                                                                _vm.selectedRowRecord
                                                              ),
                                                            size: "small",
                                                            status: "success",
                                                            content:
                                                              _vm.getProgressText(
                                                                _vm.selectedRowRecord
                                                              ),
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.selectedRowRecord
                                                      .status === "failed"
                                                      ? _c("a-progress", {
                                                          directives: [
                                                            {
                                                              name: "tippy",
                                                              rawName:
                                                                "v-tippy",
                                                              value: {
                                                                followCursor: true,
                                                                placement:
                                                                  "bottom-end",
                                                              },
                                                              expression:
                                                                "{ followCursor: true, placement: 'bottom-end' }",
                                                            },
                                                          ],
                                                          attrs: {
                                                            percent:
                                                              _vm.getPercent(
                                                                _vm.selectedRowRecord
                                                              ),
                                                            size: "small",
                                                            status: "exception",
                                                            content:
                                                              _vm.getProgressText(
                                                                _vm.selectedRowRecord
                                                              ),
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _vm.selectedRowRecord
                                                      .status === "cancelled"
                                                      ? _c("a-progress", {
                                                          directives: [
                                                            {
                                                              name: "tippy",
                                                              rawName:
                                                                "v-tippy",
                                                              value: {
                                                                followCursor: true,
                                                                placement:
                                                                  "bottom-end",
                                                              },
                                                              expression:
                                                                "{ followCursor: true, placement: 'bottom-end' }",
                                                            },
                                                          ],
                                                          attrs: {
                                                            percent:
                                                              _vm.getPercent(
                                                                _vm.selectedRowRecord
                                                              ),
                                                            size: "small",
                                                            status: "exception",
                                                            content:
                                                              _vm.getProgressText(
                                                                _vm.selectedRowRecord
                                                              ),
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "card-summary-item",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "details-subtitle",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "wp.broadcast.usageCost"
                                                            )
                                                          ) + " :"
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.getUsageCost(
                                                              _vm.selectedRowRecord
                                                            ) + " ₺"
                                                          )
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "card-summary-item",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "details-subtitle",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "wp.broadcast.sendingTime"
                                                            )
                                                          ) + " :"
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    !!_vm.selectedRowRecord
                                                      .scheduleAt
                                                      ? _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.scheduleAtHumanize(
                                                                _vm.selectedRowRecord
                                                              )
                                                            )
                                                          ),
                                                        ])
                                                      : _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.createdAtHumanize(
                                                                _vm.selectedRowRecord
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "card-main" },
                                              [
                                                _c(
                                                  "a-card",
                                                  {
                                                    staticClass: "details-card",
                                                    attrs: {
                                                      title: _vm.$t(
                                                        "wp.broadcast.customer"
                                                      ),
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      [
                                                        _c(
                                                          "a-divider",
                                                          {
                                                            staticClass:
                                                              "details-subtitle",
                                                            attrs: {
                                                              orientation:
                                                                "left",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "wp.broadcast.phoneNumbers"
                                                                )
                                                              ) +
                                                                "\n                                            "
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "contacts",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "contacts__line",
                                                              },
                                                              _vm._l(
                                                                !_vm.isMoreContacts
                                                                  ? _vm.selectedRowRecord.customPhoneNumbers.slice(
                                                                      0,
                                                                      3
                                                                    )
                                                                  : _vm
                                                                      .selectedRowRecord
                                                                      .customPhoneNumbers,
                                                                function (
                                                                  item
                                                                ) {
                                                                  return _c(
                                                                    "span",
                                                                    {
                                                                      key: item._id,
                                                                      staticClass:
                                                                        "number",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          item.number
                                                                        )
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "d-flex align-items-center flex-column mb-2",
                                                              },
                                                              [
                                                                !_vm.isMoreContacts &&
                                                                !!_vm.selectedRowRecord &&
                                                                !!_vm
                                                                  .selectedRowRecord
                                                                  .customPhoneNumbers &&
                                                                _vm
                                                                  .selectedRowRecord
                                                                  .customPhoneNumbers
                                                                  .length > 3
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "mb-1",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "..."
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                                _vm._v(" "),
                                                                !!_vm.selectedRowRecord &&
                                                                !!_vm
                                                                  .selectedRowRecord
                                                                  .customPhoneNumbers &&
                                                                _vm
                                                                  .selectedRowRecord
                                                                  .customPhoneNumbers
                                                                  .length > 3
                                                                  ? _c(
                                                                      "a-button",
                                                                      {
                                                                        attrs: {
                                                                          type: "primary",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            _vm.showMoreContact,
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            !_vm.isMoreContacts
                                                                              ? _vm.$t(
                                                                                  "wp.broadcast.showMore"
                                                                                )
                                                                              : _vm.$t(
                                                                                  "wp.broadcast.showLess"
                                                                                )
                                                                          ) +
                                                                            "\n                                                    "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    !!_vm.selectedRowRecord &&
                                                    !!_vm.selectedRowRecord
                                                      .group &&
                                                    _vm.selectedRowRecord.group
                                                      .length > 0
                                                      ? _c(
                                                          "div",
                                                          [
                                                            _c(
                                                              "a-divider",
                                                              {
                                                                staticClass:
                                                                  "details-subtitle",
                                                                attrs: {
                                                                  orientation:
                                                                    "left",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "wp.broadcast.groupDetail"
                                                                    )
                                                                  ) +
                                                                    "\n                                            "
                                                                ),
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              _vm._l(
                                                                _vm
                                                                  .selectedRowRecord
                                                                  .group,
                                                                function (
                                                                  group
                                                                ) {
                                                                  return _c(
                                                                    "div",
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  _vm.$t(
                                                                                    "wp.broadcast.groupName"
                                                                                  )
                                                                                ) +
                                                                                  " :"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "span",
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  group.name
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a-card",
                                                  {
                                                    attrs: {
                                                      title: _vm.$t(
                                                        "wp.broadcast.messages"
                                                      ),
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "messages",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "body",
                                                          },
                                                          _vm._l(
                                                            _vm
                                                              .selectedRowRecord
                                                              .messages,
                                                            function (
                                                              message,
                                                              i
                                                            ) {
                                                              return _c(
                                                                "div",
                                                                {
                                                                  key: message._id,
                                                                  staticClass:
                                                                    "payload-wrapper-message",
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "notallowed",
                                                                    },
                                                                    [
                                                                      message.type ===
                                                                      "TEXT"
                                                                        ? _c(
                                                                            "TextMessage",
                                                                            {
                                                                              staticClass:
                                                                                "not-allowed",
                                                                              attrs:
                                                                                {
                                                                                  "preview-mode": true,
                                                                                  "show-attributes": false,
                                                                                  "show-emoji": false,
                                                                                  disabled: true,
                                                                                  "whatsapp-mode": false,
                                                                                  "show-emoji-picker": false,
                                                                                  "show-placeholder": false,
                                                                                },
                                                                              model:
                                                                                {
                                                                                  value:
                                                                                    message.text,
                                                                                  callback:
                                                                                    function (
                                                                                      $$v
                                                                                    ) {
                                                                                      _vm.$set(
                                                                                        message,
                                                                                        "text",
                                                                                        $$v
                                                                                      )
                                                                                    },
                                                                                  expression:
                                                                                    "message.text",
                                                                                },
                                                                            }
                                                                          )
                                                                        : message.type ===
                                                                          "RANDOM_TEXT"
                                                                        ? _c(
                                                                            "RandomTextMessage",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  texts:
                                                                                    message.texts,
                                                                                  "preview-mode": true,
                                                                                  "show-attributes": false,
                                                                                  "show-emoji": false,
                                                                                  disabled: true,
                                                                                  "whatsapp-mode": false,
                                                                                  "show-emoji-picker": false,
                                                                                  "show-placeholder": false,
                                                                                },
                                                                            }
                                                                          )
                                                                        : message.type ===
                                                                          "GALLERY"
                                                                        ? _c(
                                                                            "GalleryMessageEditor",
                                                                            {
                                                                              staticClass:
                                                                                "not-allowed",
                                                                              attrs:
                                                                                {
                                                                                  cards:
                                                                                    message.cards,
                                                                                  "preview-mode": true,
                                                                                  "show-attributes": false,
                                                                                  "show-emoji": false,
                                                                                  disabled: true,
                                                                                  "whatsapp-mode": false,
                                                                                  "show-emoji-picker": false,
                                                                                  "show-placeholder": false,
                                                                                },
                                                                            }
                                                                          )
                                                                        : message.type ===
                                                                          "IMAGE"
                                                                        ? _c(
                                                                            "ImageBotResponse",
                                                                            {
                                                                              staticClass:
                                                                                "not-allowed",
                                                                              attrs:
                                                                                {
                                                                                  "default-image-url":
                                                                                    message.imageUrl,
                                                                                  "default-asset-id":
                                                                                    message.assetId,
                                                                                  "preview-mode": true,
                                                                                  "show-attributes": false,
                                                                                  "show-emoji": false,
                                                                                  disabled: true,
                                                                                  "whatsapp-mode": false,
                                                                                  "show-emoji-picker": false,
                                                                                  "show-placeholder": false,
                                                                                },
                                                                            }
                                                                          )
                                                                        : message.type ===
                                                                          "BUTTON"
                                                                        ? _c(
                                                                            "ButtonMessageEditor",
                                                                            {
                                                                              staticClass:
                                                                                "not-allowed",
                                                                              attrs:
                                                                                {
                                                                                  "preview-mode": true,
                                                                                  "show-attributes": false,
                                                                                  "show-emoji": false,
                                                                                  disabled: true,
                                                                                  "whatsapp-mode": false,
                                                                                  "show-emoji-picker": false,
                                                                                  "show-placeholder": false,
                                                                                },
                                                                              model:
                                                                                {
                                                                                  value:
                                                                                    _vm
                                                                                      .selectedRowRecord
                                                                                      .messages[
                                                                                      i
                                                                                    ],
                                                                                  callback:
                                                                                    function (
                                                                                      $$v
                                                                                    ) {
                                                                                      _vm.$set(
                                                                                        _vm
                                                                                          .selectedRowRecord
                                                                                          .messages,
                                                                                        i,
                                                                                        $$v
                                                                                      )
                                                                                    },
                                                                                  expression:
                                                                                    "selectedRowRecord.messages[i]",
                                                                                },
                                                                            }
                                                                          )
                                                                        : message.type ===
                                                                          "QUICK_REPLY"
                                                                        ? _c(
                                                                            "QuickReplyMessageEditor",
                                                                            {
                                                                              staticClass:
                                                                                "not-allowed",
                                                                              attrs:
                                                                                {
                                                                                  "preview-mode": true,
                                                                                  "show-attributes": false,
                                                                                  "show-emoji": false,
                                                                                  disabled: true,
                                                                                  "whatsapp-mode": false,
                                                                                  "show-emoji-picker": false,
                                                                                  "show-placeholder": false,
                                                                                },
                                                                              model:
                                                                                {
                                                                                  value:
                                                                                    _vm
                                                                                      .selectedRowRecord
                                                                                      .messages[
                                                                                      i
                                                                                    ],
                                                                                  callback:
                                                                                    function (
                                                                                      $$v
                                                                                    ) {
                                                                                      _vm.$set(
                                                                                        _vm
                                                                                          .selectedRowRecord
                                                                                          .messages,
                                                                                        i,
                                                                                        $$v
                                                                                      )
                                                                                    },
                                                                                  expression:
                                                                                    "selectedRowRecord.messages[i]",
                                                                                },
                                                                            }
                                                                          )
                                                                        : _vm._e(),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                  ]),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }